import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';
import Carousel from './components/Carousel/Carousel.js';
import YouTube from 'react-youtube-embed'

const modules = [
  {
    intlKey: '1',
    name: 'Análise de Negócios',
    txt: 'Nós criamos estruturas para solucionar problemas por meio da análise, traduzindo grandes quantidades de dados em tomadas de decisões estratégicas para o negócio. Identificamos padrões e tendências, e propondo melhorias nos processos e operações com base nesses insights.',
    youtubeId: "https://www.youtube.com/embed/4SC94uJrJZ0"
  },
  {
    intlKey: '2',
    name: 'Engenharia de Software',
    txt: 'Nós usamos práticas de desenvolvimento de software de ponta, incluindo uma variedade de tecnologias, técnicas de programação funcional e arquitetura hexagonal. Nós colaboramos com equipes multidisciplinares para traduzir requisitos em soluções técnicas.',
    youtubeId: "https://www.youtube.com/embed/98fq8i4lUKg"
  },
  {
    intlKey: '3',
    name: 'Ciência de Dados',
    txt: 'Nós utilizamos técnicas avançadas de modelagem estatística e aprendizado de máquina para extrair insights dos dados. Construímos modelos preditivos e algoritmos que ajudam a prever comportamentos e riscos para os nossos clientes.',
    youtubeId: "https://www.youtube.com/embed/UDWnAu2yXKU"
  }
];

class SectionAreasCarrossel extends PureComponent {
  constructor(props) {
    super(props);
    // this.youtubeRef = React.createRef();
    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    // if (this.youtubeRef.current) {
    //   this.youtubeRef.current.pauseVideo();
    // }

    this.setState(() => ({
      currentStep: step,
    }));
  };


  render() {
    const { currentStep } = this.state;

    return (
      <Box
        tag="section"
        // paddingBottom={{ xs: '12x', md: '10x' }}
        alignItems='center'
      //backgroundColor="white.dark"
      >

        <Box
          paddingHorizontal={{ xs: '1x', md: '12x', lg: 56 }}
          // marginTop={{ xs: '8x', md: '12x', lg: '20x' }}
          display={{ lg: 'grid' }}
          gridTemplateColumns={{ lg: 'repeat(12,1fr)' }}
          gridColumnGap={{ lg: '8x' }}
        >
          <Box
            gridColumn={{ lg: '2 / 12' }}
            maxWidth={{ md: '700px', lg: '700px' }}
            marginHorizontal={{ md: 'auto' }}
            justify='center'
            alignItems='center'
          >
            <Typography
              variant="subtitle1"
              strong
              // marginBottom={{ xs: '6x' }}
              // marginHorizontal={{ md: 'auto' }}
              // maxWidth={{ xs: '12ch', lg: 'none' }}
              textAlign='center'
              gutterBottom={1.5}
            >
              Confira mais sobre cada uma delas:
            </Typography>

            <Block
              // paddingBottom="10x"
              blockWidth="100%" textAlign="center" justifyContent="center">

              <Carousel
                textAlign='center'
                currentStep={currentStep}
                onStepChanged={this.handleChangeCarouselStep}
              // textAlign="center" justifyContent="center"
              >
                {modules.map(module => (
                  <div key={module.intlKey}>
                    <Typography
                      variant="heading4" strong
                      color="primary"
                      textAlign="center"
                      gutterBottom={1}
                      justifyContent="center">
                      {module.name}
                    </Typography>


                    <iframe id='video' width="240" height="426" src={module.youtubeId} frameborder="2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    {/*
                      <YouTube id={module.youtubeId} ref={this.youtubeRef} width="200"  height="500"/>
                     */}
                    <br />

                    <Typography
                      variant="subtitle2"
                      // tag="p"
                      // gutterBottom={1}
                      textAlign="center" justifyContent="center"
                    >
                      {module.txt}
                      {/* <FormattedMessage id={`${quote.intlKey}`}> */}
                      {/*   {/* {quote.txt} */}
                      {/*   {${quote.txt} => `"${txt}"`} */}
                      {/* </FormattedMessage> */}
                    </Typography>


                  </div>
                ))}
              </Carousel>
              <Typography variant="paragraph2" textAlign="center" justifyContent="center">
              No momento da inscrição, você deve indicar qual a sua área de preferência. Para informações detalhadas acesse a seção de "Perguntas Frequentes" desse site.
              </Typography>

            </Block>
          </Box>
        </Box>
      </Box>

    );
  }
}

export default SectionAreasCarrossel;
